import React from "react"
import BootstrapPage from "./components/BootstrapPage"
import CloudProviderContext from "./components/cloud-provider/CloudProviderContext"
import "./PageWrapper.scss"
import Layout from "./templates/layout/default/Layout"

const skipLayoutForPaths = ["/maintenance/", "/vnz/oauth/callback/"]

const PageWrapper = ({
  element,
  props,
}: {
  element: JSX.Element
  props: any
}) => {
  const { config, page } =
    props.pageContext || props.pageResources.json.pageContext

  const currentPathname = props.location.pathname
  const shouldSkipLayout = skipLayoutForPaths.includes(currentPathname)

  if (shouldSkipLayout) {
    return element
  }

  // no config available
  // this is probably a 404, we need to bypass the bootstraping of the application
  // in case of an unexisting page
  if (!config) {
    return <Layout>{element}</Layout>
  }

  return (
    <BootstrapPage pageId={page.id}>
      <CloudProviderContext>{element}</CloudProviderContext>
    </BootstrapPage>
  )
}

export default PageWrapper
